import { Button, Icon } from "@chakra-ui/react";
import React from "react";
import arrowLeft from "../../../assets/svg/arrowLeft.svg?react";
import arrowRight from "../../../assets/svg/arrowRight.svg?react";

interface PaginationProps {
  currentPage: number;
  pageCount: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  previousPage: () => void;
  nextPage: () => void;
  pageButtons: number[];
  setPage: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  pageCount,
  canPreviousPage,
  canNextPage,
  setPage,
}) => {
  let startPage = Math.max(1, currentPage - 3);
  let endPage = Math.min(pageCount, currentPage + 3);

  const pageRange = [];
  if (startPage > 1) pageRange.push(1);
  if (startPage > 2) pageRange.push("...");

  // Show pages around the current page
  for (let i = startPage; i <= endPage; i++) {
    pageRange.push(i);
  }

  if (endPage < pageCount - 1) pageRange.push("...");
  if (endPage < pageCount) pageRange.push(pageCount);

  const handleNextPage = () => {
    if (canNextPage) {
      setPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (canPreviousPage) {
      setPage(currentPage - 1);
    }
  };

  return (
    <div
      style={{
        marginTop: "20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <button
        onClick={handlePreviousPage}
        disabled={!canPreviousPage}
        style={{
          padding: "8px 12px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          backgroundColor: "transparent",
          color: !canPreviousPage ? "#94A3B8" : "#4A5769",
          borderRadius: "8px",
          boxShadow: `0px 1px 2px 0px #1018280D, 
                      0px -2px 0px 0px #1018280D inset, 
                      0px 0px 0px 1px #1018282E inset`,
        }}
      >
        <Icon as={arrowLeft} mr={2} mb={"3px"} boxSize={3} />
        Previous
      </button>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {pageRange.map((page, index) => (
          <React.Fragment key={index}>
            {typeof page === "number" ? (
              <Button
                onClick={() => setPage(page)}
                h={"40px"}
                w={"40px"}
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    page === currentPage ? "#F2F4F7" : "transparent",
                  color: "#4A5769",
                  margin: "0 5px",
                }}
              >
                {page}
              </Button>
            ) : (
              <span
                style={{
                  margin: "0 5px",
                  color: "#4A5769",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                ...
              </span>
            )}
          </React.Fragment>
        ))}
      </div>

      <button
        onClick={handleNextPage}
        disabled={!canNextPage}
        style={{
          padding: "8px 12px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          backgroundColor: "transparent",
          color: !canNextPage ? "#94A3B8" : "#4A5769",
          borderRadius: "8px",
          boxShadow: `0px 1px 2px 0px #1018280D, 
                      0px -2px 0px 0px #1018280D inset, 
                      0px 0px 0px 1px #1018282E inset`,
        }}
      >
        Next
        <Icon as={arrowRight} ml={2} mb={"3px"} boxSize={3} />
      </button>
    </div>
  );
};

export default Pagination;
